/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Box } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { AttachedSlas } from "~/components/Services/types";
import { displayEnumValue } from "~/tools/display/displayEnumValue";

type Props = {
  slas: AttachedSlas[];
};

function SLATable({ slas }: Props) {
  return (
    <Box boxStyle="lightGrey" padding="8px">
      <div className={styles.columnsContainer}>
        <span className={styles.tableHeader}>SLA name</span>
        <span className={styles.tableHeader}>SLA type</span>
        <span className={styles.tableHeader}>Support hours</span>
      </div>

      {slas.map((sla) => (
        <div key={sla.sla.id} className={styles.columnsContainer}>
          <p className={styles.tableElement}>{sla.sla.name}</p>
          <p className={styles.tableElement}>{sla.sla.slaType || "-"}</p>
          <p className={styles.tableElement}>
            {displayEnumValue(sla.sla.supportHours)}
          </p>
        </div>
      ))}
    </Box>
  );
}

export { SLATable };
